module.exports = __webpack_public_path__ + "img/blt-arrow04.dae90b80.svg";